import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { ServiceThreadSpinner } from '.';
import { api, helpers } from '../utils';

export default function VendorInfo({ vendorId, vendorName }) {
   const navigate = useNavigate();
   const [vendorInfo, setVendorInfo] = useState(null);
   const [working, setWorking] = useState(false);

   useEffect(() => {
      setWorking(true);
      api
         .fetch(`Purchasing/GetVendorInfo/${vendorId}`)
         .then(r => {
            if (r.data.success) {
               setVendorInfo(r.data.message);
            } else {
               console.error(r.data.message);
            }
         })
         .catch(api.catchHandler)
         .finally(() => setWorking(false));
   }, [vendorId])

   return (
      <>
         <div>
            <span className="h2 me-2" children="Vendor Information" />{" "}
            <span className="text-muted" >Vendor {vendorId}</span>
         </div>
         <hr />
         <ServiceThreadSpinner on={working}>
            {vendorInfo &&
               <Row className="px-4">
                  <Col xs={6}>
                     <Row>
                        <Col xs={3} className="text-end">
                           <span className="fw-bold">Vendor Status:</span>
                        </Col>
                        <Col xs={9}>
                           {vendorInfo.status}
                        </Col>
                     </Row>
                     <Row>
                        <Col xs={3} className="text-end">
                           <span className="fw-bold">Hold Status:</span>
                        </Col>
                        <Col xs={9}>
                           {vendorInfo.onHold}
                        </Col>
                     </Row>
                     <Row>
                        <Col xs={3} className="text-end">
                           <span className="fw-bold">Payment Terms:</span>
                        </Col>
                        <Col xs={9}>
                           {vendorInfo.paymentTerms}
                        </Col>
                     </Row>
                     <Row>
                        <Col xs={3} className="text-end">
                           <span className="fw-bold">Current Balance:</span>
                        </Col>
                        <Col xs={9}>
                           {helpers.formatCurrency(vendorInfo.ageCurrent)}
                        </Col>
                     </Row>
                     <Row>
                        <Col xs={3} className="text-end">
                           <span className="fw-bold">Balance 0-30:</span>
                        </Col>
                        <Col xs={9}>
                           {helpers.formatCurrency(vendorInfo.age0To30)}
                        </Col>
                     </Row>
                     <Row>
                        <Col xs={3} className="text-end">
                           <span className="fw-bold">Balance 31-60:</span>
                        </Col>
                        <Col xs={9}>
                           {helpers.formatCurrency(vendorInfo.age31To60)}
                        </Col>
                     </Row>
                     <Row>
                        <Col xs={3} className="text-end">
                           <span className="fw-bold">Balance 61-90:</span>
                        </Col>
                        <Col xs={9}>
                           {helpers.formatCurrency(vendorInfo.age61To90)}
                        </Col>
                     </Row>
                     <Row>
                        <Col xs={3} className="text-end">
                           <span className="fw-bold">Balance 90+:</span>
                        </Col>
                        <Col xs={9}>
                           {helpers.formatCurrency(vendorInfo.age91Plus)}
                        </Col>
                     </Row>
                     <Row>
                        <Col xs={3} className="text-end">
                           <span className="fw-bold">YTD Purchases:</span>
                        </Col>
                        <Col xs={9}>
                           {helpers.formatCurrency(vendorInfo.ytdPurchases)}
                        </Col>
                     </Row>
                     <Row>
                        <Col xs={3} className="text-end">
                           <span className="fw-bold">Last YTD Purchases:</span>
                        </Col>
                        <Col xs={9}>
                           {helpers.formatCurrency(vendorInfo.pytdPurchases)}
                        </Col>
                     </Row>
                  </Col>
                  <Col xs={6}>
                     <div className="mb-5">
                        <Row className="mb-2">
                           <Col>
                              <span className="h5 text-muted text-uppercase">Purchasing Address</span>
                              <Button
                                 className="shredButton ms-2"
                                 onClick={() => navigate(`/ea/Purchasing/${vendorId}`)}
                              >
                                 Edit
                              </Button>
                           </Col>
                        </Row>
                        <Row>
                           <Col className="text-uppercase">
                              {vendorInfo.address1}
                           </Col>
                        </Row>
                        {vendorInfo.address2.length > 0 &&
                           <Row>
                              <Col className="text-uppercase">
                                 {vendorInfo.address2}
                              </Col>
                           </Row>
                        }
                        {vendorInfo.address3.length > 0 &&
                           <Row>
                              <Col className="text-uppercase">
                                 {vendorInfo.address3}
                              </Col>
                           </Row>
                        }
                        <Row>
                           <Col className="text-uppercase">
                              {vendorInfo.city}, {vendorInfo.state} {vendorInfo.zip}
                           </Col>
                        </Row>
                        <Row>
                           <Col className="text-uppercase">
                              Contact: {vendorInfo.contact}
                           </Col>
                        </Row>
                        <Row>
                           <Col className="text-uppercase">
                              Phone: {helpers.formatPhoneNumber(vendorInfo.phone)}
                           </Col>
                        </Row>
                        <Row>
                           <Col className="text-uppercase">
                              Fax: {helpers.formatPhoneNumber(vendorInfo.fax)}
                           </Col>
                        </Row>
                        <Row>
                           <Col className="text-uppercase">
                              <a href={`mailto:${vendorInfo.eMail}`} className="shredLink">
                                 {vendorInfo.eMail}
                              </a>
                           </Col>
                        </Row>
                     </div>
                     <div>
                        <Row className="mb-2">
                           <Col>
                              <span className="h5 text-muted text-uppercase">Remit To Contact Info</span>
                           </Col>
                        </Row>
                        <Row>
                           <Col className="text-uppercase">
                              Phone: {helpers.formatPhoneNumber(vendorInfo.remitPhone)}
                           </Col>
                        </Row>
                        <Row>
                           <Col className="text-uppercase">
                              Fax: {helpers.formatPhoneNumber(vendorInfo.remitFax)}
                           </Col>
                        </Row>
                        <Row>
                           <Col className="text-uppercase">
                              <a href={`mailto:${vendorInfo.remitEMail}`} className="shredLink">
                                 {vendorInfo.remitEMail}
                              </a>
                           </Col>
                        </Row>
                     </div>
                  </Col>
               </Row>}
         </ServiceThreadSpinner>
      </>
   );
}